<template>
  <div class="container">
    <Card back add>
      <template v-slot:header>
        <h3>مدیـریـت پرسشنــامه ها</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container">
          <div class="row m-2"></div>
          <div class="row m-2">
            <div @click="Edit(item)" class="col-12 border Pointer py-2 Rounded m-2" :key="index" v-for="(item, index) in Quastionares">
              <div class="row">
                <div class="pt-2 col-10">
                  <h5>{{ item.name }}</h5>
                </div>
                <div class="col-2 pt-1">
                  <span class="float-left mt-2"> <i class="fad fa-pencil"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'

export default {
  data() {
    return {
      Quastionares: [],
    }
  },
  components: { Card },
  created() {
    this.GetQuastionares()
  },
  methods: {
    GetQuastionares() {
      var DataAxios = {
        Action: 'TblCrmCombo/GetComboById',
        Method: 'POST',
        ArryfildValue: { Id: 18 },
      }
      this.$PostData(DataAxios).then((result) => {
        // console.log(result)
        this.Quastionares = result
      })
    },
    Edit(data) {
      // console.log('data', data)
      this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', QName: data.name, QId: data.id } })
    },
  },
}
</script>
<style scoped>
.Rounded:hover {
  background: var(--sidebar-action-bg);
}
</style>
